import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../../utils/common.constants';

@Injectable()
export class TelemedicineService { 
  constructor(private http: HttpClient) {
  }
 
  save(saveData): Observable<any> {
    return this.http.post(CommonConstants.TELEMEDICINE_SAVE, saveData).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getPractitionersById(prteId: number): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/partner/practitioner/' + prteId).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }


  errorHandler(error: any): void {
    throwError(error);
  };

  searchTeleMedicines(obj, startIndex) {
    return this.http.post(CommonConstants.env + 'api/partner/telemedicine/search' + '?start=' + startIndex + '&size='
      + CommonConstants.PAGINATION_SIZE, obj)
  }

  getTelemedicineById(id: number): Observable<any> {
    return this.http.get(CommonConstants.env + 'api/partner/telemedicine/' + id).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

}
